import { Component, OnInit } from '@angular/core';
import { TooltipPosition } from './enum/tooltip-position.enum';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  position: TooltipPosition = TooltipPosition.DEFAULT;
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;
}
